import { createApp } from "vue";
import { createI18n } from 'vue-i18n'
import messages from '../locales/messages.json'
import { Component } from 'vue';
import { RouteRecordRaw } from "vue-router";
import { Store } from "vuex";
import { createWidgetRouter } from "./routerUtils";

export interface WidgetConfig {
  name: string;
  widget: Component;
  routes?: RouteRecordRaw[];
  store?: Store<unknown>;
  i18n?: boolean;
}

export function createWidget(config: WidgetConfig): void {
  document.querySelectorAll(`[data-vue-widget-${config.name}]`).forEach(element => {
    const widget = createApp(config.widget, { ...(element as any).dataset })
    if (config.routes) {
      widget.use(createWidgetRouter(config.routes))
    }
    if (config.store) {
      widget.use(config.store)
    }
    if (config.i18n) {
      const i18n = createI18n({
        allowComposition: true,
        locale: { ...(element as any).dataset }.locale || 'de',
        messages
      })
      widget.use(i18n)
    }
    widget.mount(element);
  })
}

export function createWidgets(configs: WidgetConfig[]): void {
  configs.forEach(config => createWidget(config))
}
